const initialState = {
    loading: false,
    detail: null,
    error: null,
};

export default function accessTokenReducer(state = initialState, action) {
    switch (action.type) {
        case "TOKEN_LOADING":
            return { ...state, loading: true };
        case "TOKEN_SUCCESS":
            return { ...state, loading: false, detail: action.payload };
        case "TOKEN_ERROR":
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
}
